import { useState } from "react";
import { useGetAuftragFilesMutation, useGetDownloadAuftragsDateienAsZipMutation } from "../../api/AuftragAPI";

interface ThisProps {
  uidAuftrag: string;
}

/**
 * @author noone
 */
const AuftragFilesDownloadButtonComponent: React.FC<ThisProps> = (props) => {

  const [getAuftragDateien] = useGetDownloadAuftragsDateienAsZipMutation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  const handleDownload = async () => {
    setIsLoading(true);
    const { blob, filename } =
      await getAuftragDateien(props.uidAuftrag)
        .unwrap()
        .finally(() => setIsLoading(false))
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <button className="btn btn-secondary" onClick={handleDownload}>
        <i className="bi bi-download"></i> Download
      </button>
    </>
  );

}

export default AuftragFilesDownloadButtonComponent;